import AppManager from './lib/app-manager'
import PetiteVueAppManager from './lib/types/petite-vue-app-manager'

export default function registerAppManager() {
  AppManager._register()
  PetiteVueAppManager.registerHooks()
}
